(() => {
  if (window.__vmFitToLookInitialized) return;
  window.__vmFitToLookInitialized = true;

  const recentKey = 'vm_recent_product_handles_v1';
  const track = (event, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...detail });
    document.dispatchEvent(new CustomEvent(event, { detail }));
  };

  const readRecent = () => {
    try { return JSON.parse(localStorage.getItem(recentKey) || '[]').filter(Boolean).slice(0, 20); }
    catch (_) { return []; }
  };

  const rememberAnchor = () => {
    const pdp = document.querySelector('[data-vm-fit-to-look][data-vm-surface="pdp"][data-anchor]');
    if (!pdp) return;
    const anchor = pdp.dataset.anchor;
    const recent = [anchor, ...readRecent().filter((item) => item !== anchor)].slice(0, 20);
    try { localStorage.setItem(recentKey, JSON.stringify(recent)); } catch (_) {}
  };

  const personalizeHome = () => {
    const carousel = document.querySelector('[data-vm-home-look-carousel]');
    if (!carousel) return;
    const recent = readRecent();
    if (!recent.length) return;
    const cards = [...carousel.querySelectorAll('[data-vm-look-card]')];
    cards.sort((a, b) => {
      const score = (card) => {
        const handles = (card.dataset.products || '').split(',').map((handle) => handle.trim()).filter(Boolean);
        let best = 999;
        recent.forEach((handle, index) => {
          if (card.dataset.anchor === handle || handles.includes(handle)) best = Math.min(best, index);
        });
        return best;
      };
      return score(a) - score(b);
    }).forEach((card) => carousel.appendChild(card));
  };

  const sendAdd = async (variantId, button, status, lookId) => {
    if (!variantId || button.disabled) return;
    const original = button.textContent;
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections }
    }));
    if (!sections.length) sections.push('cart-drawer');

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = '…';
    if (status) status.textContent = 'Adding to your bag…';
    track('vm_look_quick_add', { look_id: lookId, variant_id: String(variantId) });

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: [...new Set(sections)],
          sections_url: window.location.pathname
        })
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add this item.');
      button.textContent = '✓';
      if (status) status.textContent = 'Added to your bag.';
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart: payload }
      }));
      track('vm_look_add_success', { look_id: lookId, variant_id: String(variantId) });
      window.setTimeout(() => { button.textContent = original; button.disabled = false; button.removeAttribute('aria-busy'); }, 1600);
    } catch (error) {
      button.textContent = original;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (status) status.textContent = error.message || 'Unable to add this item. Try again.';
      track('vm_look_add_error', { look_id: lookId, variant_id: String(variantId) });
    }
  };

  document.addEventListener('click', (event) => {
    const direct = event.target.closest('[data-vm-direct-add]');
    if (direct) {
      event.preventDefault();
      sendAdd(direct.dataset.vmDirectAdd, direct, null, direct.dataset.lookId || '');
      return;
    }

    const trigger = event.target.closest('[data-vm-dialog-trigger]');
    if (trigger) {
      event.preventDefault();
      const dialog = document.getElementById(trigger.dataset.vmDialogTrigger);
      if (dialog?.showModal) dialog.showModal();
      else if (dialog) dialog.setAttribute('open', '');
      track('vm_look_option_open', { look_id: trigger.dataset.lookId || '' });
      return;
    }

    const close = event.target.closest('[data-vm-dialog-close]');
    if (close) {
      const dialog = close.closest('dialog');
      if (dialog?.close) dialog.close();
      else dialog?.removeAttribute('open');
      return;
    }

    const add = event.target.closest('[data-vm-dialog-add]');
    if (add) {
      const dialog = add.closest('[data-vm-look-dialog]');
      const select = dialog?.querySelector('[data-vm-variant-select]');
      const status = dialog?.querySelector('[data-vm-add-status]');
      sendAdd(select?.value, add, status, add.dataset.lookId || '');
      return;
    }

    const link = event.target.closest('[data-vm-look-product-link]');
    if (link) track('vm_look_product_click', { look_id: link.dataset.lookId || '', product_url: link.getAttribute('href') });
  });

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries, instance) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      track('vm_look_impression', { look_id: entry.target.dataset.lookId || '', surface: entry.target.closest('[data-vm-surface]')?.dataset.vmSurface || '' });
      instance.unobserve(entry.target);
    });
  }, { threshold: .45 }) : null;
  document.querySelectorAll('[data-vm-look-card]').forEach((card) => observer?.observe(card));

  rememberAnchor();
  personalizeHome();
})();

